const KEY = 'votes';

/**
 *
 * @returns {Object<string,*>}
 */
export function getVotes() {
  return JSON.parse(localStorage.getItem(KEY) ?? '{}');
}

/**
 *
 * @param {number} reviewId
 */
export function saveVote(reviewId) {
  const votes = getVotes();
  const existingVoteIndex = votes[reviewId];

  if (existingVoteIndex) {
    throw new Error('Vote exists');
  } else {
    votes[reviewId] = 'positive';
  }

  localStorage.setItem(KEY, JSON.stringify(votes));
}

/**
 *
 * @param {number} reviewId
 */
export function getUserVotes(reviewId) {
  const votes = getVotes();

  return votes[reviewId];
}
